import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaPassword.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
import { WINDOW } from "constants/environment"
import { InputPassword, Button, H3, A, FormGroup, P, Content, TickModalIcon, Alert, Caption } from "AtomicComponents"
import { AlertList, HeroContent } from "AtomicContainers"
import { lengthCheck, hasLowerUpperCase, hasNumber, hasSymbol } from 'AtomicUtils/string'
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"

class MyMazdaPassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        password: {
          validations: {
            required: MESSAGES.PASSWORD_REQUIRED
          }
        },
        confirmPassword: {
          validations: {
            required: MESSAGES.PASSWORD_REQUIRED,
            confirmPassword: "Passwords do not match"
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()

    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const currentURL = new urlHandler(WINDOW.location.href)
        const { accountActivationApiEndpoint, buttonText } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "POST",
          url: accountActivationApiEndpoint,
          body: {
            email: currentURL.query.email,
            guid: currentURL.query.token,
            password: form.password.value
          }
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "MyMazda Password Form",
                  pageAction: `MyMazda Password Form - ${buttonText}`
                })
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  passwordStrengthIndicator() {
    const { form } = this.state
    const icon = (
      <TickModalIcon
        style={{
          height: '20px',
          float: 'left',
          margin: '1px 0.5em 0 0',
          width: '20px'
        }}
      />
    )
    const invalid = (
      <span className={classnames({
        [styles.MyMazdaPasswordInvalid]: true
      })} />
    )
    const style = { lineHeight: '20px', color: '#191919' }
    const val = form.password.value

    return (
      <div className={classnames({
        [styles.MyMazdaPasswordStrength]: true
      })}>
        <Content xmlString={'Please select a password that has'} />
        <P>{lengthCheck(val, 8, 20) ? icon : invalid} 8-20 characters.</P>
        <P>{hasLowerUpperCase(val) ? icon : invalid} Upper and lowercase letters.</P>
        <P>{hasNumber(val) || hasSymbol(val) ? icon : invalid} One number or one symbol.</P>
      </div>
    )
  }

  render() {
    const {
      heading, buttonText = "Next", successHeading, passswordUpdateSuccessfulText, successfulPageUrl, redirectPageUrl
    } = this.props
    const { loading, errorMessage, success } = this.state

    if (success) {
      return (
        <div className={classnames({ [styles.MyMazdaPassword]: true })}>
          <div className={classnames({ [styles.MyMazdaPasswordForm]: true })}>
            <FormGroup>
              <TickModalIcon style={{ width: "2.25em", height: "2.25em", margin: "0 auto" }} />
              <HeroContent
                heading={successHeading || "New password created"}
                description={passswordUpdateSuccessfulText} />
              <Button styleName="black" href={successfulPageUrl} fullWidth>
                Login to MyMazda
              </Button>
            </FormGroup>
          </div>
        </div>
      )
    }

    return (
      <div className={classnames({
        [styles.MyMazdaPassword]: true
      })}>
        <div className={classnames({
          [styles.MyMazdaPasswordForm]: true
        })}>
          <form method="POST" onSubmit={this._handleSubmit}>
            <FormGroup>
              <H3 withDetails>
                {heading}
              </H3>
            </FormGroup>
            <FormGroup>
              {this.passwordStrengthIndicator()}
            </FormGroup>

            <FormGroup>
              <InputPassword
                name="password"
                label="Create password"
                {...fromLinkInputs(this, "password")}
                onBlur={()=>{
                  gtmHandler({
                    pageCategory: "MyMazda Password Form",
                    pageAction: "MyMazda Password Form - Entered \"PASSWORD\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputPassword
                name="confirmPassword"
                label="Confirm password"
                {...fromLinkInputs(this, "confirmPassword")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda Password Form",
                    pageAction: "MyMazda Password Form - Entered \"CONFIRM PASSWORD\""
                  })
                }}
              />
            </FormGroup>

            <FormGroup>
              {
                errorMessage &&
                errorMessage === "TokenExpired" ?
                <Alert>
                  Oh no! Your password has expired. Please <A href={redirectPageUrl}><Caption>click this link</Caption></A> and follow the prompts to create a new one.
                </Alert>
                :
                <AlertList data={errorMessage} />
              }

              <Button
                styleName="black"
                loading={loading}
                fullWidth
                {...formLinkSubmit(this, this._handleSubmit)}
              >
                {buttonText}
              </Button>
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}


export default MyMazdaPassword



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaPassword/MyMazdaPassword.jsx